import { Check, Copy } from 'lucide-react';
import * as React from 'react';
import { Button } from '../../../atoms/button';
import type { CodeBlock } from '../chat-content';

export function CodeBlockRenderer({ block }: { block: CodeBlock }) {
  const [copied, setCopied] = React.useState(false);

  function copy() {
    navigator.clipboard.writeText(block.content).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="overflow-hidden rounded-lg border border-border text-sm">
      {/* Header bar */}
      <div className="flex items-center justify-between border-b border-border bg-muted/60 px-3 py-1.5">
        <span className="font-mono text-xs text-muted-foreground">{block.language ?? 'plain'}</span>
        <Button
          type="button"
          appearance="ghost"
          size="icon"
          className="size-6"
          aria-label="Copy code"
          onClick={copy}
        >
          {copied ? <Check className="size-3.5 text-success" /> : <Copy className="size-3.5" />}
        </Button>
      </div>
      {/* Code body */}
      <pre className="overflow-x-auto bg-muted/30 px-4 py-3 text-xs font-mono leading-relaxed">
        <code>{block.content}</code>
      </pre>
    </div>
  );
}
